var _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 82,
    viewBox: "0 0 117 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_118_9085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 0,
    width: 55,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.9162 0.651166L35.4109 25.1325C34.5395 26.0028 34.5395 27.4116 35.4109 28.2819L59.9287 52.7695C60.355 53.1952 60.9129 53.4144 61.4709 53.4206H61.5398C62.0977 53.4144 62.6557 53.1952 63.082 52.7695L87.5935 28.2819C88.4649 27.4116 88.4649 26.0028 87.5935 25.1325L63.0757 0.651166C62.6431 0.219143 62.0727 0 61.5022 0C60.9317 0 60.3612 0.219143 59.9287 0.651166",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_118_9085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4945 -26.9263L7.79541 26.7065L61.4945 80.3394L115.194 26.7065L61.4945 -26.9263Z",
    fill: "url(#paint0_linear_118_9085)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_118_9085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 9,
    width: 36,
    height: 36
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7806 9.84866L22.6411 24.9757C22.2461 25.3702 22.0267 25.8711 21.9766 26.3845V26.7978C22.0204 27.3112 22.2461 27.8121 22.6411 28.2065L37.8871 43.4338C38.7836 44.3229 40.2317 44.3229 41.1282 43.4338L56.2677 28.3067C57.1642 27.4114 57.1642 25.965 56.2677 25.0759L41.0216 9.84866C40.5765 9.40412 39.9872 9.17871 39.4042 9.17871C38.8212 9.17871 38.2319 9.40412 37.7868 9.84866",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_118_9085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5633 -8.3923L4.38623 26.7537L39.5756 61.8874L74.7527 26.7414L39.5633 -8.3923Z",
    fill: "url(#paint1_linear_118_9085)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_118_9085",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 14,
    width: 24,
    height: 25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3694 26.1654C34.0748 26.4597 34.0748 26.9418 34.3694 27.2361L45.8667 38.7192L57.3576 27.2361C57.6523 26.9418 57.6523 26.4597 57.3576 26.1654L45.8604 14.6824L34.3631 26.1654H34.3694Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_118_9085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8673 2.90546L22.0454 26.698L45.8673 50.4905L69.6893 26.698L45.8673 2.90546Z",
    fill: "url(#paint2_linear_118_9085)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.00162558 72.7603C-0.0220448 72.3624 0.214655 72.1496 0.589435 72.1496H3.17345C3.52456 72.1496 3.71392 72.3387 3.78493 72.713C3.9743 73.5562 4.67652 73.9778 6.06123 73.9778C7.58797 73.9778 8.0811 73.3907 8.0811 72.713C8.0811 71.7516 6.90942 71.33 5.47736 70.8375C3.15372 70.0416 0.218605 69.0802 0.218605 65.4907C0.218605 62.2085 2.89335 60.5654 5.68646 60.5654C8.47956 60.5654 11.0636 62.043 11.3437 65.4434C11.3673 65.8413 11.1306 66.0541 10.7559 66.0541H8.17184C7.82073 66.0541 7.63137 65.865 7.56036 65.4907C7.371 64.6238 6.76345 64.2259 5.68251 64.2259C4.50688 64.2259 3.97035 64.813 3.97035 65.4907C3.97035 66.4757 4.93295 66.9446 6.29399 67.4371C8.6413 68.2567 11.8329 69.0999 11.8329 72.713C11.8329 75.9952 9.20544 77.6383 6.05729 77.6383C2.90913 77.6383 0.281725 76.1607 0.00162558 72.7603Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6364 66.1722V81.4128C25.6364 81.7872 25.4234 81.9999 25.0486 81.9999H22.7013C22.3265 81.9999 22.1135 81.7872 22.1135 81.4128V76.2157C21.3284 77.1102 20.1883 77.6381 18.6182 77.6381C15.541 77.6381 13.0083 74.943 13.0083 71.4481C13.0083 67.9531 15.545 65.2581 18.6182 65.2581C20.1883 65.2581 21.3324 65.786 22.1135 66.6805V66.1722C22.1135 65.7979 22.3265 65.5851 22.7013 65.5851H25.0486C25.4234 65.5851 25.6364 65.7939 25.6364 66.1722ZM22.1135 71.4481C22.1135 69.6908 20.9418 68.5875 19.3204 68.5875C17.699 68.5875 16.5273 69.6908 16.5273 71.4481C16.5273 73.2054 17.7029 74.3087 19.3204 74.3087C20.9379 74.3087 22.1135 73.2054 22.1135 71.4481Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2408 66.1723V76.7242C38.2408 77.0985 38.0277 77.3112 37.6529 77.3112H35.3056C34.9309 77.3112 34.7178 77.0985 34.7178 76.7242V76.2395C34.1655 77.0551 33.1674 77.6383 31.6683 77.6383C29.4827 77.6383 27.9126 75.9519 27.9126 73.0204V66.1723C27.9126 65.798 28.1256 65.5852 28.5004 65.5852H30.8477C31.2225 65.5852 31.4355 65.798 31.4355 66.1723V72.713C31.4355 73.8872 32.118 74.3994 33.0096 74.3994C34.0669 74.3994 34.7218 73.8124 34.7218 72.4293V66.1684C34.7218 65.7941 34.9348 65.5813 35.3096 65.5813H37.6569C38.0317 65.5813 38.2447 65.7941 38.2447 66.1684",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.565 69.9232V76.724C50.565 77.0983 50.352 77.3111 49.9772 77.3111H47.7246C47.3498 77.3111 47.1368 77.0983 47.1368 76.724V76.3891C46.5095 77.1259 45.5824 77.6381 44.107 77.6381C42.0397 77.6381 40.2329 76.4206 40.2329 73.9816C40.2329 71.5426 42.0397 70.3251 44.107 70.3251C45.5824 70.3251 46.5056 70.7388 47.1368 71.2195V70.1596C47.1368 69.013 46.6673 68.4969 45.681 68.4969C44.9551 68.4969 44.5094 68.7766 44.32 69.1785C44.178 69.5055 44.0596 69.6947 43.7085 69.6947H41.4085C41.0338 69.6947 40.7971 69.4819 40.8207 69.0839C41.1245 66.5504 43.2864 65.262 45.681 65.262C48.2611 65.262 50.565 66.7632 50.565 69.9271M47.1368 73.9816C47.1368 73.2566 46.5016 72.8114 45.3536 72.8114C44.2726 72.8114 43.7558 73.3039 43.7558 73.9816C43.7558 74.6593 44.2726 75.1518 45.3536 75.1518C46.5055 75.1518 47.1368 74.6593 47.1368 73.9816Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8067 65.3962C59.2052 65.3253 59.4182 65.5853 59.4182 65.9596V68.7257C59.4182 69.1 59.2525 69.2891 58.9487 69.2891C57.635 69.2418 56.3647 69.8998 56.3647 71.7754V76.7243C56.3647 77.0986 56.1517 77.3113 55.7769 77.3113H53.4296C53.0548 77.3113 52.8418 77.0986 52.8418 76.7243V66.1724C52.8418 65.7981 53.0548 65.5853 53.4296 65.5853H55.7769C56.1517 65.5853 56.3647 65.7981 56.3647 66.1724V67.4412C56.7158 66.263 57.639 65.5735 58.8067 65.4001V65.3962Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3306 71.4481C72.3306 71.7515 72.3069 72.0352 72.2832 72.315C72.2359 72.6893 72.0031 72.8548 71.6481 72.8548H63.8092C64.2353 74.2496 65.332 74.8012 66.555 74.8012C67.2138 74.8012 67.8687 74.5648 68.2948 74.2141C68.5275 74.025 68.7169 73.9068 69.0207 73.9068L71.2733 73.8832C71.6954 73.8832 71.9321 74.1629 71.7428 74.5412C70.8275 76.5822 68.9023 77.6342 66.5077 77.6342C62.6099 77.6342 60.1206 74.9391 60.1206 71.4442C60.1206 67.9492 62.7046 65.2542 66.413 65.2542C69.8412 65.2542 72.3306 67.902 72.3306 71.4442M68.8234 70.1794C68.4605 68.8437 67.4229 68.3748 66.3893 68.3748C65.0677 68.3748 64.1564 69.0092 63.7935 70.1794H68.8234Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6909 69.1038C73.6909 64.2731 77.5176 60.5693 82.2359 60.5693C86.9542 60.5693 90.7809 64.2731 90.7809 69.1038C90.7809 73.9345 86.9542 77.6382 82.2359 77.6382C77.5176 77.6382 73.6909 73.9345 73.6909 69.1038ZM87.0252 69.1038C87.0252 66.1723 84.9146 64.2258 82.2359 64.2258C79.5572 64.2258 77.4466 66.1723 77.4466 69.1038C77.4466 72.0353 79.5572 73.9817 82.2359 73.9817C84.9146 73.9817 87.0252 72.0353 87.0252 69.1038Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.102 69.8759V76.724C103.102 77.0983 102.889 77.3111 102.514 77.3111H100.167C99.7917 77.3111 99.5787 77.1022 99.5787 76.724V70.1833C99.5787 69.0091 98.9001 68.4969 98.0046 68.4969C96.9473 68.4969 96.2925 69.0839 96.2925 70.467V76.7279C96.2925 77.1022 96.0794 77.315 95.7047 77.315H93.3573C92.9826 77.315 92.7695 77.1062 92.7695 76.7279V66.1761C92.7695 65.8018 92.9826 65.589 93.3573 65.589H95.7047C96.0794 65.589 96.2925 65.7978 96.2925 66.1761V66.6607C96.8448 65.8451 97.8429 65.262 99.342 65.262C101.524 65.262 103.098 66.9484 103.098 69.8799",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117 71.4481C117 71.7515 116.976 72.0352 116.953 72.315C116.905 72.6893 116.673 72.8548 116.318 72.8548H108.479C108.905 74.2496 110.001 74.8012 111.224 74.8012C111.883 74.8012 112.538 74.5648 112.964 74.2141C113.197 74.025 113.386 73.9068 113.69 73.9068L115.943 73.8832C116.365 73.8832 116.602 74.1629 116.412 74.5412C115.497 76.5822 113.572 77.6342 111.177 77.6342C107.279 77.6342 104.79 74.9391 104.79 71.4442C104.79 67.9492 107.374 65.2542 111.082 65.2542C114.511 65.2542 117 67.902 117 71.4442M113.493 70.1794C113.13 68.8437 112.096 68.3748 111.059 68.3748C109.737 68.3748 108.826 69.0092 108.463 70.1794H113.493Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_118_9085",
    x1: 47.0252,
    y1: 41.7814,
    x2: 74.6562,
    y2: 14.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FC2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#46C3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#59C8EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79D1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_118_9085",
    x1: 26.3461,
    y1: 40.8828,
    x2: 44.703,
    y2: 22.4967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71429A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#784199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8C3E97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#AD3994"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#DB3390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9328F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_118_9085",
    x1: 38.504,
    y1: 18.7595,
    x2: 50.5198,
    y2: 30.7901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#883795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#803592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6A328B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#482D80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#392B7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0e16852063cf8b1702110a17c43b3199.svg";
export { ForwardRef as ReactComponent };